<template>
  <vue-modal :active="active" container-class="bg-smoke" @closed="$emit('closed')">
    <div class="box p-0">
      <shop-form :model="shop"
                   :resource="resource"
                   :action="action"
                   :canUpdate="canUpdate"
                   :canDelete="canDelete"
                   @created="handleCreated"
                   @updated="handleUpdated"
                   @deleted="handleDeleted"/>
    </div>
  </vue-modal>
</template>

<script>
import modal from '../../mixins/modal';
import resource from '../../mixins/resource';
import ShopForm from './ShopForm.vue';

export default {
  mixins: [modal, resource],

  components: { ShopForm },

  computed: {
    shop() {
      return this.data;
    },
    resource() {
      return 'shops';
    },
  },

  methods: {
    handleCreated(shop) {
      Event.fire('shopCreated', shop);
    },
    handleUpdated(shop) {
      Event.fire('shopUpdated', shop);
    },
    handleDeleted(shop) {
      Event.fire('shopDeleted', shop);
    },
  },
};
</script>